<template>
  <b-modal
    size="xl"
    centered
    hide-footer
    no-close-on-esc
    v-model="showModal"
    no-close-on-backdrop
    title="Movimentações do Projeto Astec"
    @show="onModalShow"
    @hidden="onModalClose"
  >
    <div>
      <transition name="fade" mode="out-in">
        <div
          v-if="loading"
          key="spinner"
          class="d-flex justify-content-center align-items-center rounded"
          style="height:350px;background: #F4F4F5;"
        >
          <b-spinner variant="primary" label="Carregando..." />
        </div>
        <grid
          v-else
          key="grid"
          :small="false"
          :hover="false"
          :colunas="colunas"
          :carregando="false"
          :itensPorPagina="10"
          :dados="movimentacoes"
          :paginacaoAtiva="false"
        />
      </transition>
    </div>
  </b-modal>
</template>

<script>
import grid from "@/components/grid";

export default {
  components: { grid },
  props: {
    isOpenModal: { type: Boolean, default: false },
    dadosMovimentacao: { type: [Object, Array], default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      movimentacoes: [],
      showModal: this.isOpenModal,
      colunas: [
        { key: "sequencia", label: "Sequência", sortable: false },
        {
          key: "tipoOperacao",
          label: "Tipo Operação",
          settingsLine: {
            corLinha: "#F5F5F5",
            icon: "fa fa-plus-square",
            condicao: (item) => item.tipoOperacao === "LANÇAMENTO",
          },
          sortable: false
        },
        {
          sortable: false,
          key: "tipoOperacao",
          class: 'text-center',
          label: "Tipo Operação",
          settingsLine: {
            corLinha: '',
            textColor: '',
            icon: 'fa fa-arrow-right',
            condicao: item => item.tipoOperacao === "BAIXA",
          },
        },
        { key: "mesReferencia", label: "Mês Referência", sortable: false },
        { key: "lancamento", label: "Lançamento", sortable: false },
        { key: "vencimento", label: "Vencimento", sortable: false },
        { key: "valor", label: "Valor", sortable: false },
        { key: "natureza", label: "Natureza", sortable: false },
        { key: "saldo", label: "Saldo", sortable: false },
        { key: "status", label: "Status", sortable: false },
        { key: "evento", label: "Evento", sortable: false },
        { key: "numeroDocumento", label: "Nº Documento", sortable: false },
      ],
    };
  },
  watch: {
    isOpenModal(value) {
      this.showModal = value;
    },
    dadosMovimentacao(newVal) {
      if (this.showModal && Array.isArray(newVal?.data?.data)) {
        this.mostrarResumo();

      }
    }
  },
  methods: {
    async onModalShow() {
      this.loading = true;
      this.movimentacoes = [];
    },

    onModalClose() {
      this.movimentacoes = [];
      this.loading = false;
      this.$emit("update:isOpenModal", false);
    },

    async mostrarResumo() {
      const movimentacoesApi = this.dadosMovimentacao?.data?.data;
      if (!Array.isArray(movimentacoesApi)) {
        this.loading = false;
        return;
      }

      const movimentacoesFormatadas = movimentacoesApi.map(item => ({
        evento: item.evento,
        status: item.st_lcto,
        sequencia: item.sequencia,
        natureza: item.tp_natureza,
        tipoOperacao: item.tp_operacao,
        numeroDocumento: item.documento,
        valor: this.formataSaldo(item.valor),
        saldo: this.formataSaldo(item.saldo),
        vencimento: this.formatDate(item.vencimento),
        lancamento: this.formatDate(item.lancamento),
        mesReferencia: this.formatMesReferencia(item.mesreferencia),
      }));

      this.movimentacoes = movimentacoesFormatadas;
      this.loading = false;
    },

    formatMesReferencia(data) {
      const date = new Date(data);
      return `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${date.getFullYear()}`;
    },
    formataSaldo(valorSaldo) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valorSaldo);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
